import React, { useState, useContext } from "react";
// import theme from "../../index.scss";

import { ThemeContext, PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";
import { translateSymptom } from "../../i18n/translateData";

import SymptomTracker from "./SymptomTracker";

import { format, compareDesc } from "date-fns";
import getLoggedDataToday from "../../lib/getLoggedDataToday";

// prop drilling but necessary for SymptomTracker component 🥲
function SymptomPicker({
    currentTrackingStep,
    topSymptoms,
    date,
    user,
    trackedData,
    saveTrackingStep,
    loadTrackedData,
}) {
    const { dark } = useContext(ThemeContext);
    const { patient } = useContext(PatientContext);
    const { t } = useTranslation();
    const [selectedSymptom, setSelectedSymptom] = useState(null);

    const colors = {
        motor: "#b3e5fc",
        sensory: "#ffccbc",
        emotional: "#dab7ec",
        behavioral: "#ffdadb",
        cognitive: "#ffdcaf",
        immune: "#fff3c4",
        metabolic: "#cef3c4",
    };

    const todayLogs = getLoggedDataToday(trackedData, "medical", date) || [];
    const loggedTodayFactors = new Set(todayLogs.map((x) => x.factor));

    return (
        <>
            {selectedSymptom === null ? (
                <>
                    <h6 className="d-flex justify-content-between">
                        <span>
                            {patient.userPatientRelationshipType == "self"
                                ? t("dashboard.trackSymptom.patient")
                                : t("dashboard.trackSymptom.nonPatientName", { name: patient.firstName })}
                        </span>
                        <span>{format(date, "LLL d, yyyy")}</span>
                    </h6>
                    {/* inner box */}
                    <div
                        className="p-3 m-3"
                        style={{
                            borderRadius: "5px",
                            boxShadow: "0px 0px 2px 1px rgba(0,0,0,0.75)",
                        }}
                    >
                        <h6 style={{ textAlign: "center" }}>
                            {t("dashboard.trackSymptomsForDay")}
                        </h6>
                        <div
                            className="d-flex flex-wrap"
                            style={{ marginTop: "1rem", gap: "12px 16px" }}
                        >
                            {topSymptoms.map((s) => {
                                const bg =
                                    colors[s.subcategory.toLowerCase()] ||
                                    "#eee";
                                const done = loggedTodayFactors.has(s.factor);

                                return (
                                    <button
                                        key={s.factor}
                                        type="button"
                                        disabled={done}
                                        onClick={() =>
                                            !done && setSelectedSymptom(s)
                                        }
                                        className="px-3 py-2"
                                        style={{
                                            backgroundColor: bg,
                                            border: "none",
                                            borderRadius: 999,
                                            minWidth: 140,
                                            textAlign: "center",
                                            cursor: done
                                                ? "not-allowed"
                                                : "pointer",
                                            opacity: done ? 0.55 : 1,
                                            color: "black",
                                        }}
                                    >
                                        <strong>{translateSymptom(t, s.factor, s.subcategory)}</strong>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </>
            ) : (
                <SymptomTracker
                    currentTrackingStep={currentTrackingStep}
                    topSymptoms={topSymptoms}
                    date={date}
                    user={user}
                    symptom={selectedSymptom}
                    trackedData={trackedData}
                    saveTrackingStep={saveTrackingStep}
                    loadTrackedData={loadTrackedData}
                    handleBack={() => setSelectedSymptom(null)}
                />
            )}
        </>
    );
}

export default SymptomPicker;